export default {
  TRUE: 'true',
  FALSE: 'false',
};
